/**
 * The microphone, as a bar, and the line that says why it is not moving.
 *
 * `aria-hidden` on the bar, because the line under it says the same thing in
 * words - a moving bar is unreadable to a screen reader and a level is not
 * information anybody has to have.
 *
 * That line is ALWAYS in the document, empty when there is nothing to say. It
 * carries "waiting for permission", which is true for a second or two after the
 * panel opens and then stops being true; rendered conditionally it took a line
 * of height away with it, and inside a dropdown anchored to a button that is the
 * whole panel jumping just as somebody reaches for a device name.
 *
 * The level arrives as a REF, not as a prop. This component renders three times
 * in the life of the panel - off, asking, live - and the bar inside it moves
 * sixty times a second without any of them; `useInputLevel` writes the
 * transform onto the node itself.
 */
import type { MutableRefObject } from "react";
import { useT } from "../../../i18n/I18nProvider";
import type { InputLevelState } from "./useInputLevel";

export function Meter({
  barRef,
  state,
}: {
  barRef: MutableRefObject<HTMLElement | null>;
  state: InputLevelState;
}) {
  const t = useT();
  const note =
    state === "denied" ? t("calls.audio.micDenied") : state === "asking" ? t("calls.audio.micAsking") : "";
  return (
    <>
      <div className="crm-lvl" aria-hidden="true">
        <i ref={barRef} />
      </div>
      <p className="crm-audio-note crm-audio-mnote">{note}</p>
    </>
  );
}
